import axios from 'axios'

export default {
    state: {
        lead: {
            api_token: '',
            dealer_id: 11,
            date: '',
            hour: '',
            first_name: '',
            last_name: '',
            email: null,
            phone_number: null,
            registration_number: '',
            description: '',
            door_to_door: 0,
            replacement_car: '0',
            model_id: null,
            model_val: null,
            brand_id: null,//BMW
            // additional
            brand_val: null,
            comment_val: null,
            services_val: [],
            visit_date_val: null,
            visit_hour_val: null,
            additional_options_val: [],
            postcode_val: null,
            city_val: null,
            street_val: null,
            country_val: null,
            phone_number_additional_val: null,
            accept1_val: false,
            mileage: null,
            vin: null,
            model_id: null,
            replacement_car_val: null,
            // term preferences
            date_from: null,
            hour_from: null,
            hour_to: null,
            term_key: null,
            service_time: 0,//szacowany czas naprawy
            visit_hour_name: '', // nazwa pory dnia
            // replacement car
            replacement_car_id: null,
            // advisor
            advisor_id: null,
            repair: null,
            mechanic_id: null,
            mechanic_hour: null
        },
        leadToDescription: {
            brand_val: "Marka",
            model_id: "Model",
            vin: "Vin",
            mileage: "Przebieg",
            postcode_val: "Kod pocztowy",
            city_val: "Miasto",
            country_val: "Kraj",
            phone_number_additional_val: "Dodatkowy numer telefonu",
            accept1_val: "Zgoda RODO",
            additional_options_val: "Dodatkowe opcje",
            comment_val: "Komentarz",
            visit_date_val: "Szukał terminu od",
            visit_hour_name: "Pora dnia",
            service_time: "Szacowany czas naprawy",
            replacement_car_val: "Samochód zastępczy",
            street_val: 'Adres'
        },
        errors: [],
        validation: {
            dealer_id: {
                method: (e) => e != null,
                message: 'wybrać lokalizację'
            },
            date: {
                method: (e) => e != '',
                message: 'wybrać datę wizyty'
            },
            hour: {
                method: (e) => e != '',
                message: 'wybrać godzinę wizyty'
            },
            first_name: {
                method: (e) => e != '',
                message: 'uzupełnić imię'
            },
            last_name: {
                method: (e) => e != '',
                message: 'uzupełnić nazwisko'
            },
            email: {
                method: (e) => e != '',
                message: 'uzupełnić adres e-mail'
            },
            phone_number: {
                method: (e) => e != '',
                message: 'uzupełnić numer telefonu'
            },
            // registration_number: {
            //     method: (e) => e != '',
            //     message: 'uzupełnić numer rejestracyjny'
            // },
            description: {
                method: (e) => true,
                message: ''
            },
            door_to_door: {
                method: (e) => true,
                message: ''
            },
            replacement_car: {
                method: (e) => true,
                message: ''
            },
            model_id: {
                method: (e) => e != null,
                message: 'wybrać model'
            },
            brand_id: {
                method: (e) => e != null,
                message: 'wybrać markę'
            },
            // additional
            brand_val: {
                method: (e) => e != null,
                message: 'wybrać model'
            },
            comment_val: {
                method: (e) => true,
                message: ''
            },
            services_val: {
                method: (e) => e.length > 0,
                message: 'wybrać usługę serwisową'
            },
            visit_date_val: {
                method: (e) => e != null,
                message: 'datę wizyty'
            },
            visit_hour_val: {
                method: (e) => e != null,
                message: 'wybrać datę wizyty'
            },
            additional_options_val: {
                method: (e) => true,
                message: ''
            },
            postcode_val: {
                method: (e) => e != null,
                message: 'uzupełnić kod pocztowy'
            },
            city_val: {
                method: (e) => e != null,
                message: 'uzupełnić miasto'
            },
            // country_val: {
            //     method: (e) => e != null,
            //     message: 'uzupełnić kraj'
            // },
            phone_number_additional_val: {
                method: (e) => true,
                message: ''
            },
            accept1_val: {
                method: (e) => e != false,
                message: 'wyrazić zgodę na przetwarzanie danych'
            },
            // mileage: {
            //     method: (e) => e != null,
            //     message: 'uzupełnić przebieg pojazdu'
            // },
            vin: {
                method: (e) => e != null,
                message: 'uzupełnić numer VIN'
            },
            model_id: {
                method: (e) => e != null,
                message: 'wybrać model'
            },
            replacement_car_val: {
                method: (e) => true,
                message: ''
            },
            // term preferences
            date_from: {
                method: (e) => true,
                message: ''
            },
            hour_from: {
                method: (e) => true,
                message: ''
            },
            hour_to: {
                method: (e) => true,
                message: ''
            },
            term_key: {
                method: (e) => true,
                message: ''
            },
            service_time: {
                method: (e) => true,
                message: ''
            },//szacowany czas naprawy
            visit_hour_name: {
                method: (e) => true,
                message: ''
            }, // nazwa pory dnia
            // replacement car
            replacement_car_id: {
                method: (e) => true,
                message: ''
            },
            // advisor
            advisor_id: {
                method: (e) => true,
                message: ''
            },
            repair: {
                method: (e) => true,
                message: ''
            },
            mechanic_id: {
                method: (e) => e != null,
                message: 'wybrać datę wizyty'
            },
            mechanic_hour: {
                method: (e) => e != null,
                message: 'wybrać datę wizyty'
            },
        },
        leadResponse: false
    },
    mutations: {
        setLead(state, payload) { state.lead = payload },
        setLeadResponse(state, payload) { state.leadResponse = payload },
        setValidation(state, payload) { state.validation = payload },
        setErrors(state, payload) { state.errors = payload }
    },
    getters: {
        getLead: state => state.lead,
        getValidation: state => state.validation,
        getLeadResponse: state => state.leadResponse,
        getErrors: state => state.errors

    },
    actions: {
        async sendLead({ commit, state, rootState }) {
            const ready = await this._vm.$recaptchaLoaded();
            if (ready) {

                const token = await this._vm.$recaptcha('login');

                if (token) {

                    // szacowany czas naprawy
                    state.lead.service_time = state.lead.services_val.length;

                    let description = Object.keys(state.leadToDescription).map(k => {

                        let value = [null, false].includes(state.lead[k]) ? '-' : state.lead[k];

                        return state.leadToDescription[k] + ": " + value + "/\n";
                    });

                    description += "/\n Wybrane usługi serwisowe: " + state.lead.services_val.map(e => {
                        return rootState.definitions.services.find(s => s.val === e) ? rootState.definitions.services.find(s => s.val === e).name : e
                    })

                    state.lead.description += description;


                    var formData = new FormData()
                    Object.keys(state.lead).forEach((key) => {
                        formData.append(key, [null, false, ''].includes(state.lead[key]) ? '-' : state.lead[key])
                    });

                    formData.append('recaptcha_token', token);

                    var xmlHttp = new XMLHttpRequest()
                    xmlHttp.onreadystatechange = function () {
                        if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
                            let response = JSON.parse(xmlHttp.responseText);
                            commit('setLeadResponse', response)
                            dataLayer.push({ 'event': 'form_submit' });
                        }
                    }
                    xmlHttp.open('post', 'https://jlr.serwis.inchcape.pl/send')
                    xmlHttp.send(formData)

                }

            }

        }
    },
    namespaced: true
}